import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingState = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={4}
    >
      <CircularProgress size={48} />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Loading experiments...
      </Typography>
    </Box>
  );
};

export default LoadingState;
